<div class="site-shell min-h-screen bg-slate-100 dark:bg-slate-950">
  <app-header />
  @if (notice().enabled) {
  <aside class="border-b border-amber-200 bg-amber-50 text-amber-950 dark:border-amber-400/20 dark:bg-amber-950/40 dark:text-amber-100" [attr.aria-label]="'siteNotice.label' | translate">
    <div class="mx-auto flex max-w-[1800px] items-start gap-2.5 px-4 py-2.5 text-xs leading-relaxed sm:px-6 lg:items-center lg:justify-center lg:px-8">
      <svg class="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400 lg:mt-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">
        <circle cx="12" cy="12" r="9" />
        <path stroke-linecap="round" d="M12 11v6M12 7h.01" />
      </svg>
      <p class="whitespace-pre-wrap break-words min-w-0">
        {{ language() === 'en' ? (notice().message_en || notice().message_fr) : notice().message_fr }}
      </p>
    </div>
  </aside>
  }
  <main>
    <div class="w-full max-w-[1800px] mx-auto px-4 sm:px-6 lg:px-8 pb-20 xl:pb-0">
      <router-outlet />
    </div>
  </main>
</div>
